export default {
  nav: {
    title: 'Review Process',
  }
}
